<template>
  <div>
    <div class="ScpmSearchContainer">
      <scpm-sub-title>
        {{title}}
        <template slot="action">
          <slot name="action"></slot>
        </template>
      </scpm-sub-title>
      <scpm-divider style="marginTop:8px;marginBottom:14px" />
      <slot name="content"></slot>
    </div>
    <slot name="buttons">
      <div class="ScpmSearchButtons">
        <lego-button @click="$emit('reset')" v-if="!noReset">{{$util.capitalize($t('button.reset'))}}</lego-button>
        <lego-button @click="$emit('search')" :disabled="searchDisabled">{{$util.capitalize($t('button.search'))}}</lego-button>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  name: 'ScpmSearch',
  props: {
    title: {
      type: String,
      default: '검색조건',
    },
    noReset:{
      type:Boolean,
      default:false
    },
    searchDisabled:{
      type:Boolean,
      default:false
    }
  },
};
</script>
<style lang="scss" scoped>
.ScpmSearchContainer {
  margin: 8px 0;
  padding: 20px;
  border-radius: 6px;
  background-color: var(--color-primary-tint-01);

  .action {
    display: flex;
    justify-content: flex-end;
  }
}
.ScpmSearchButtons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>